function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useUpsertGroupMutation, useDeleteGroupMutation, useGetAccountQuery, useListPortfolioGroupsQuery, useAssignVenturesToGroupMutation } from '~/types/types';
export default defineComponent({
  props: {
    selected: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props, _ref) {
    var _accountResult$value;
    var emit = _ref.emit;
    var _useGetAccountQuery = useGetAccountQuery(),
      accountResult = _useGetAccountQuery.result;
    var account = (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount;
    var portfolioId = computed(function () {
      return account === null || account === void 0 ? void 0 : account.id;
    });
    var _useListPortfolioGrou = useListPortfolioGroupsQuery(),
      result = _useListPortfolioGrou.result,
      refetch = _useListPortfolioGrou.refetch,
      loading = _useListPortfolioGrou.loading;
    var groups = computed(function () {
      var _result$value$listPor, _result$value;
      return (_result$value$listPor = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listPortfolioGroups) !== null && _result$value$listPor !== void 0 ? _result$value$listPor : [];
    });
    var _useUpsertGroupMutati = useUpsertGroupMutation(),
      addGroup = _useUpsertGroupMutati.mutate;
    var _useDeleteGroupMutati = useDeleteGroupMutation(),
      removeGroup = _useDeleteGroupMutati.mutate;
    var _useAssignVenturesToG = useAssignVenturesToGroupMutation(),
      mutate = _useAssignVenturesToG.mutate,
      onAssignDone = _useAssignVenturesToG.onDone;
    onAssignDone(function () {
      window.$nuxt.$emit('userMsg');
    });
    var assign = function assign() {
      var _props$selected;
      if (props !== null && props !== void 0 && (_props$selected = props.selected) !== null && _props$selected !== void 0 && _props$selected.length && selectedGroups) {
        var groupAssignments = Object.keys(selectedGroups.value).map(function (groupId) {
          return {
            groupId: parseInt(groupId),
            ventureIds: selectedGroups.value[groupId]
          };
        });
        mutate({
          groupId: 1,
          groupAssignments: groupAssignments,
          ventureIds: props.selected.map(function (s) {
            return s.ventureId;
          }),
          deleteOldVentureIds: false
        }).then(function () {
          emit('close');
        });
      }
    };
    var groupName = ref('');
    var selectedGroup = ref(0);
    var selectedGroups = ref({});
    var selectedVentures = computed(function () {
      return props.selected.map(function (s) {
        return s.ventureId;
      });
    });
    var groupsWithStatus = computed(function () {
      var _result$value$listPor2, _result$value2;
      var statusMap = {};
      var groupsList = (_result$value$listPor2 = (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.listPortfolioGroups) !== null && _result$value$listPor2 !== void 0 ? _result$value$listPor2 : [];
      var tempSelectedGroups = {};

      // status: This is to determine initial status of checkboxes
      // If all selected ventures already assigned to group -> show checkbox as Checked
      // If some ventures already assigned to group -> show checkbox as Indeterminate
      // If all selected ventures not assigned to group -> show checkbox as not Checked
      var determineVentureStatus = function determineVentureStatus(venturesLength, selectedLength) {
        if (venturesLength === selectedLength) {
          return 'AllAssigned';
        } else if (venturesLength > 0) {
          return 'Indeterminate';
        } else {
          return 'NoneAssigned';
        }
      };
      var _iterator = _createForOfIteratorHelper(groupsList),
        _step;
      try {
        var _loop = function _loop() {
          var item = _step.value;
          var ventures = props.selected.filter(function (selected) {
            var _selected$groupIds;
            return (_selected$groupIds = selected.groupIds) === null || _selected$groupIds === void 0 ? void 0 : _selected$groupIds.includes(item.id);
          });
          var listOfVentureIds = ventures.map(function (venture) {
            return venture.ventureId;
          });
          statusMap[item.id] = {
            group: item,
            ventures: ventures,
            status: determineVentureStatus(ventures.length, props.selected.length)
          };
          tempSelectedGroups[item.id] = listOfVentureIds;
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      selectedGroups.value = tempSelectedGroups;
      return statusMap;
    });
    var handleChange = function handleChange(groupId, value) {
      if (value === true) {
        selectedGroups.value[groupId] = selectedVentures.value;
      } else if (value === false) {
        selectedGroups.value[groupId] = [];
      } else {
        console.log('Not handled.');
      }
    };
    var form = ref();
    var upsertGroup = function upsertGroup(insert) {
      var input = ref();
      if (insert === true) {
        input.value = {
          label: groupName.value
        };
      } else {
        input.value = {
          id: selectedToEdit.value,
          label: selectedToEditLabel.value
        };
      }
      addGroup({
        input: input.value
      }).then(function () {
        isAddGroup.value = false;
        isEditGroup.value = false;
        refetch();
      });
    };
    var deleteGroup = function deleteGroup() {
      removeGroup({
        groupId: selectedToDelete.value
      }).then(function () {
        isDeleteGroup.value = false;
        refetch();
        emit('close');
      });
    };
    var isAddGroup = ref(false);
    var isDeleteGroup = ref(false);
    var isEditGroup = ref(false);
    var selectedToDelete = ref(0);
    var selectedToDeleteLabel = ref('');
    var selectedToEdit = ref(0);
    var selectedToEditLabel = ref('');
    var getGroupRowKey = function getGroupRowKey(item, idx) {
      return item && item.group && item.group.id != null ? item.group.id : idx;
    };
    return {
      loading: loading,
      isAddGroup: isAddGroup,
      isDeleteGroup: isDeleteGroup,
      selectedToDelete: selectedToDelete,
      selectedToDeleteLabel: selectedToDeleteLabel,
      selectedGroup: selectedGroup,
      selectedGroups: selectedGroups,
      groupsWithStatus: groupsWithStatus,
      getGroupRowKey: getGroupRowKey,
      upsertGroup: upsertGroup,
      deleteGroup: deleteGroup,
      handleChange: handleChange,
      selectedVentures: selectedVentures,
      selectedToEdit: selectedToEdit,
      isEditGroup: isEditGroup,
      selectedToEditLabel: selectedToEditLabel,
      portfolioId: portfolioId,
      groups: groups,
      addGroup: addGroup,
      assign: assign,
      groupName: groupName,
      form: form
    };
  }
});